// Copyright (c) Docugami, Inc. All rights reserved.
export enum DocxCustomProperty {
    FolderId = "DocugamiFolderId",
    OrgId = "DocugamiOrgId"
}

export async function getCustomProperty(context: Word.RequestContext, property: DocxCustomProperty): Promise<string>
{
    const customProperty = context.document.properties.customProperties.getItemOrNullObject(property);
    context.load(customProperty);
    await context.sync();

    if (!customProperty || customProperty.value === '') {
        return '';
    }

    return customProperty.value;
}

export async function setCustomProperty(context: Word.RequestContext, property: DocxCustomProperty, value: string): Promise<void>
{
    context.document.properties.customProperties.add(property, value);
    await context.sync();
}
